import React from 'react';
import styled from 'styled-components';

const InputWrap = styled.div`
  width: 100%;
  margin-bottom: 20px;
  label {
    color: #74777E;
  }

  input {
    width: 100%;
  }
`

const NoticeMessage = styled.span`
  color: #FF6E30;
  font-size: 12px;
  margin-top: 10px;
  margin-bottom: 20px;
  line-height: 16px;
`

const ErrorMessage = styled.span`
  color: #FF6E30;
  font-size: 12px;
  line-height: 16px;
  margin-top: 10px;
`

const RadiosContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  div {
    display: flex;
    flex: 1;
  }
`

export default ({title, placeholder, errorMessage, noticeMessage}) => {
  return (
    <InputWrap>
      <label>
        {title}
      </label>
      {noticeMessage && (
        <NoticeMessage>
          {noticeMessage}
        </NoticeMessage>
      )}
      {/* <RadiosContainer>
        <div>
          <input type="radio" />
        </div>
        <div>
          <input type="radio" />
        </div>
      </RadiosContainer> */}
    </InputWrap>
  )
}